module.exports = __webpack_public_path__ + "static/media/dot-icon.065846ba.svg";